import { axiosInstance } from '../../axios';
import {
  CreatePresetPayload,
  Preset,
  UpdatePresetPayload,
} from './preset.interface';

export function fetchPresets() {
  return axiosInstance
    .get<Preset[]>('/api/preset')
    .then((response) => response.data);
}

export function fetchPreset(id: string) {
  return axiosInstance
    .get<Preset>(`/api/preset/${id}`)
    .then((response) => response.data);
}

export function createPreset(payload: CreatePresetPayload) {
  return axiosInstance
    .post<Preset>('/api/preset', payload)
    .then((response) => response.data);
}

export function updatePreset(id: string, payload: UpdatePresetPayload) {
  return axiosInstance
    .patch<Preset>(`/api/preset/${id}`, payload)
    .then((response) => response.data);
}

export function deletePreset(id: string) {
  return axiosInstance
    .delete<Preset>(`/api/preset/${id}`)
    .then((response) => response.data);
}
